<div class="main-content">
  <app-side-menu></app-side-menu>
  <div class="right-content">
    <app-top-menu></app-top-menu>
    @if (isload) {
      <div class="loading-animation" role="alert" aria-live="assertive">
        <app-loading></app-loading>
      </div>
    }
    @if (!isload) {
      <div class="content">
        <div class="back-btn">
          <button class="btn" (click)="goToCampaigns()" style="float: left">
            <img src="../../assets/Icons/arrow-left-line.png" alt="Back" />
          </button>
          <span style="overflow: hidden;">
            Campanhas /
          </span>
          <span class="separador" (click)="goToCampaign()">
            {{campaign?.name}}
          </span>
          <span style="overflow: hidden; margin-left: 5px;">
            /
          </span>
          <span class="separador">
            {{campaignGroup?.description}}
          </span>
        </div>
        @if (!(showCampaignGroupImage().endsWith('webm') || showCampaignGroupImage().endsWith('mp4'))) {
          <div>
            <img [src]="showCampaignGroupImage()" alt="Imagem da Campanha" class="img-campanha" />
          </div>
        }
        @if ((showCampaignGroupImage().endsWith('webm')) || (showCampaignGroupImage().endsWith('mp4'))) {
          <div>
            <video autoplay muted loop [src]="showCampaignGroupImage()" alt="Vídeo da Campanha"
            class="img-campanha"></video>
          </div>
        }
        <!-- Group PDF attachment -->
        @if (campaignGroup?.pdfGroup && campaignGroup?.pdfGroup !== '') {
          <div class="file" (click)="onFileClick(campaignGroup?.pdfGroup!)">
            <mat-icon>attach_file</mat-icon>
            <span>{{ getOriginalFileName(campaignGroup?.pdfGroup!) }}</span>
          </div>
        }
        @if (campaignGroup?.products?.length! > 1) {
          <div class="div-span">
            <span class="span-inter">
              Produtos em Destaque
            </span>
          </div>
        }
        <div class="mt-4">
          <div class="d-flex flex-row flex-wrap justify-content-start" style="gap:20px">
            @for (product of campaignGroup?.products; track product) {
              <app-product-shop [product]="product">
              </app-product-shop>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
